import './classes/Header.css';
import { configData } from "../config";
import React, { useState, useEffect, useRef } from "react";
const Header = () => {

    const [user, setUser] = useState(null);
    const app_url = configData.APP_URL;
    // Function to check login status
    const checkLoginStatus = async () => {
        const user = localStorage.getItem("user");
        if (!user) return null;

        try {
            const response = await fetch(app_url + "site/status", {
                headers: { "Authorization": `Bearer ${user}` },
            });

            if (response.ok) return await response.json(); // returns user object
            localStorage.removeItem("user");
            return null;
        } catch (error) {
            console.error("Error checking login status:", error);
            return null;
        }
    };

    // Logout function
    const handleLogout = async () => {
        const user = localStorage.getItem("user");

        try {
            await fetch(app_url + "site/logout", {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${user}`,
                    "Content-Type": "application/json",
                },
            });
        } catch (error) {
            console.error("Logout error:", error);
        }

        localStorage.removeItem("user");
        setUser(null);
        // window.location.href = "/login";
    };

    useEffect(() => {
        const verifyLogin = async () => {
            const data = await checkLoginStatus();
            if (data?.user) {
                setUser(data.user);
                localStorage.setItem("user", JSON.stringify(data.user));
            }
        };
        verifyLogin();
    }, []);

    return (

        <header className="header">     
            <div className="flex">
                <img
                src="/images/logo (2).png"
                alt="Logo"
                className=""
                />
                <span className="app-name">
                ShopLite POS
                </span>
            </div><div>
                <ul>
                    {user ? (
                        <>
                        <li>Welcome, {user.username}</li>
                        {/* {user.role === "admin" && (
                            <li><a href="/inventory-management">Inventory</a></li>
                        )}
                        <li><a href="/productentry">POS</a></li> */}
                        <li><a onClick={handleLogout}>Logout</a></li>
                        </>
                    ) : (
                        <li><a href="/login">Login</a></li>
                    )}
                </ul>
            </div>
        </header>
    );
    };

export default Header;